export default __webpack_public_path__ + "static/media/34B0C0D4-D364-49A3-94A9-D93F25AD01A9.f6f04891.jpeg";